import DocumentService from '@/Modules/Document/DocumentService.js'

export default class EntityDocumentService extends DocumentService {
  static resource = 'entities'
}
